import React from 'react';
import { StyledUploadModalHeaderContainer, StyledUploadModalHeaderLabel, StyledUploadModalHeaderSubtitle, StyledUploadModalHeaderTitle, StyledUploadModalSwitchContainer, StyledUploadModalTextContainer } from './styles';
import { Switch } from "../inputs";
export const FileUploadHeader = ({ title, subtitle, showCompleted, onShowCompletedChange, switchId = 'showCompletedSwitch', switchLabel, shouldHideCompletedCheckbox }) => {
    return (React.createElement(StyledUploadModalHeaderContainer, null,
        !shouldHideCompletedCheckbox && (React.createElement(StyledUploadModalSwitchContainer, null,
            React.createElement(Switch, { checked: showCompleted, onClick: onShowCompletedChange, id: switchId }),
            React.createElement(StyledUploadModalHeaderLabel, null, switchLabel))),
        React.createElement(StyledUploadModalTextContainer, null,
            React.createElement(StyledUploadModalHeaderTitle, null, title),
            React.createElement(StyledUploadModalHeaderSubtitle, null, subtitle))));
};
//# sourceMappingURL=FileUploadHeader.js.map